import React, { useState } from 'react';
import { SELECTED_VIDEO_INPUT_KEY } from '../../../constants';
import { FormControl, MenuItem, Typography, Select } from '@material-ui/core';
import { LocalVideoTrack } from 'twilio-video';
import { makeStyles } from '@material-ui/core/styles';
import VideoTrack from '../../VideoTrack/VideoTrack';
import useDevices from '../../../hooks/useDevices/useDevices';
import useMediaStreamTrack from '../../../hooks/useMediaStreamTrack/useMediaStreamTrack';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles({
	preview: {
		width: '300px',
		maxHeight: '200px',
		margin: '0.5em auto',
		'& video': {
			maxHeight: '200px',
		},
	},
});

export default function VideoInputList() {
	const classes = useStyles();
	const { videoInputDevices } = useDevices();
	const { localTracks, restartVideoTrack, onError } = useVideoContext();

	const localVideoTrack = localTracks.find(
		(track) => track.kind === 'video',
	) as LocalVideoTrack | undefined;
	const mediaStreamTrack = useMediaStreamTrack(localVideoTrack);
	const [storedLocalVideoDeviceId, setStoredLocalVideoDeviceId] = useState(
		window.localStorage.getItem(SELECTED_VIDEO_INPUT_KEY),
	);
	const localVideoInputDeviceId =
		mediaStreamTrack?.getSettings().deviceId || storedLocalVideoDeviceId;

	function replaceTrack(newDeviceId: string) {
		void restartVideoTrack({ deviceId: { exact: newDeviceId } })
			.then(() => {
				setStoredLocalVideoDeviceId(
					window.localStorage.getItem(SELECTED_VIDEO_INPUT_KEY),
				);
			})
			.catch(() =>
				onError(
					new Error(
						'Unable to change your video device. Please try again.',
					),
				),
			);
	}

	return (
		<div>
			{localVideoTrack && (
				<div className={classes.preview}>
					<VideoTrack isLocal track={localVideoTrack} />
				</div>
			)}
			{videoInputDevices.length > 1 ? (
				<FormControl fullWidth>
					<Typography variant="subtitle2" gutterBottom>
						Video Input
					</Typography>
					<Select
						onChange={(e) => replaceTrack(e.target.value as string)}
						value={localVideoInputDeviceId || ''}
						variant="outlined"
					>
						{videoInputDevices.map((device) => (
							<MenuItem
								value={device.deviceId}
								key={device.deviceId}
							>
								{device.label}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			) : (
				<>
					<Typography variant="subtitle2" gutterBottom>
						Video Input
					</Typography>
					<Typography>
						{localVideoTrack?.mediaStreamTrack.label ||
							'No Local Video'}
					</Typography>
				</>
			)}
		</div>
	);
}
